import axios from "axios";
import { createJWTToken } from "../utils/createJWTToken";

export const getAllSpecialitiesData = () => {
  const result = axios({
    method: "GET",
    url: process.env.REACT_APP_BACKEND_URL + "/api/v1/specialities",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "bearer " + createJWTToken(),
    },
  }).then((response) => {
    const result: {
      created_at: string;
      updated_at: string;
      order: number;
      id: number;
      name: string;
    }[] = response.data.data;

    const updatedArray = result.map(
      ({ created_at, updated_at, order, ...rest }) => ({ ...rest })
    );

    return updatedArray;
  });

  return result;
};
